import {createReducer} from 'util/redux'
import {KontStammTO} from 'generated/JavaTO'
import {kontStammResponseAction} from 'module/KontStamm/KontStammAction'
import moment from 'moment'

interface KontStammState {
	byPersNr: {
		[persNr in number]: {
			fetchTS: { ts: number, start: number, end: number }[],
			models: KontStammTO[]
		}
	}
}

const KontStammReducer = createReducer<KontStammState>({byPersNr: {}}, builder => builder
	.addCase(kontStammResponseAction, (state, {payload}) => {
		const {byPersNr} = state
		const {params} = payload
		return ({
			...state,
			byPersNr: params.persNrs.reduce((ret, persNr) => {
				if (!ret[persNr]) ret[persNr] = {models: [], fetchTS: []}
				const forPersNr = ret[persNr]
				const models = payload.response.filter(m => m.persNr === persNr)
				const minVondat = Math.min(params.startDate, ...models.map(m => m.vondat))
				const maxBisdat = Math.max(params.endDate, ...models.map(m => m.bisdat))
				forPersNr.models = [
					...forPersNr.models.filter(model => model.vondat > maxBisdat || model.bisdat < minVondat),
					...models,
				].sort(
					(a, b) => b.vondat - a.vondat,
				)
				forPersNr.fetchTS = [
					{ts: +moment(), start: minVondat, end: maxBisdat},
					...forPersNr.fetchTS.filter(f => f.start > maxBisdat || f.end < minVondat).slice(0, 9),
				]
				return ret
			}, {...byPersNr}),
		})
	}),
)


export const KontStammReducerNS = {KontStamm: KontStammReducer}
export type KontStammStateType = { KontStamm: ReturnType<typeof KontStammReducerNS.KontStamm> }